const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5/org',
    component: Import('org/index'),
    name: 'orgIndex',
    meta: { title: '公证处' }
  },
  {
    path: '/h5/org/detail/:orgId',
    component: Import('org/detail'),
    name: 'orgDetail',
    meta: { title: '公证处详情' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/org.js